import { useEffect, useState } from 'react'

type Countdown = {
  /** «мм:сс», or «чч:мм:сс» past an hour. Frozen at 00:00 when expired. */
  label: string
  isExpired: boolean
}

const pad = (value: number) => String(value).padStart(2, '0')

function toCountdown(deadline: string, now: number): Countdown {
  const remaining = Math.max(0, Math.floor((new Date(deadline).getTime() - now) / 1000))

  const hours = Math.floor(remaining / 3600)
  const minutes = Math.floor((remaining % 3600) / 60)
  const seconds = remaining % 60

  return {
    label:
      hours > 0
        ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
        : `${pad(minutes)}:${pad(seconds)}`,
    isExpired: remaining === 0,
  }
}

/**
 * A ticking clock for invoice expiry. State holds only the clock; the
 * countdown itself is derived at render, so a deadline change never needs an
 * effect to resynchronise.
 */
export function useCountdown(deadline: string): Countdown {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(Date.now())
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return toCountdown(deadline, now)
}
